import React, { useEffect, useState, useRef } from "react";
import { Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { getAccountType, AccountWayOfAction } from "../types";
import ProfileForm from "../ProfileForm";
import { preCheckAccountForm } from "../../preCheckForms";
import { CircularProgress } from "../../../..";
import { AccountMode, showToast } from "../../../../utils/Helper";

const ProfileTab = ({
  account,
  userType,
  isReadOnly,
  currencies,
  riskTypes,
  setAccountData,
  companyLinks,
  reps,
  services,
  mode,
  setTabErrors,
  enableField,
  setRedirectAccount,
  newOnboardingVersion = false,
  AutomaticRep = false,
  newTLFormulaEnabled = false,
  userRoles,
}) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [changedAccount, setChangedAccount] = useState({});
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(mode === AccountMode.New ? false : true);
  const valueref = useRef();
  const accountref = useRef();

  const handleSave = () => {
    const changedAccountRef = valueref.current;
    const fullaccount = accountref.current;
    const postAccount = {
      ...fullaccount,
      ...changedAccountRef,
    };

    if (mode === AccountMode.New) {
      setLoadingSave(true);
      const newErrors = preCheckAccountForm(postAccount, { skipAdvisorValidation: AutomaticRep });
      if (Object.keys(newErrors).length !== 0) {
        setLoadingSave(false);
        setErrors(newErrors);
        showToast("Changes not saved", true);
        return;
      }
      if (newOnboardingVersion) {
        const baseBody = {
          trnmode: "INS",
          accountId: 0,
          accountData: JSON.stringify({
            Entity: "Account",
            Data: {
              AccountId: postAccount.AccountId,
              AccountReference: postAccount.AccountReference,
              AccountName: postAccount.AccountName,
              AccountCurrencyId: postAccount.AccountCurrencyId == 0 ? 1 : postAccount.AccountCurrencyId,
              AccountNumber: postAccount.AccountNumber,
              AccountServiceType: postAccount.AccountServiceType,
              AccountUsage: postAccount.AccountUsage,
              AccountEmail: postAccount.AccountEmail,
              AccountOpeningDate:
                postAccount.AccountOpeningDate === "0000-00-00"
                  ? new Date().toISOString().slice(0, 10)
                  : postAccount.AccountOpeningDate,
              AccountPrintAccountStatement: postAccount.AccountPrintAccountStatement,
              AccountFoundsOrigin: postAccount.AccountFoundsOrigin,
              AccountFoundsOriginDescription: postAccount.AccountFoundsOriginDescription,
              AccountFoundsOriginType: postAccount.AccountFoundsOriginType,
              AccountFoundsOriginTypeDescipt: postAccount.AccountFoundsOriginTypeDesciption,
              AccountPotentiality: postAccount.AccountPotentiality,
              AccountCustomerType: postAccount.AccountCustomerType,
              AccountReference2: postAccount.AccountReference2,
              AccountReference3: postAccount.AccountReference3,
              AccountProfileObjective: postAccount.AccountProfileObjective,
              AccountProfileTerm: postAccount.AccountProfileTerm,
              AccountLastUpdateDate:
                postAccount.AccountLastUpdateDate === "0000-00-00"
                  ? new Date().toISOString().slice(0, 10)
                  : postAccount.AccountLastUpdateDate,
              AccountRisk: postAccount.AccountRisk,
              AccountMoreOperativeCountryId: postAccount.AccountMoreOperativeCountryId,
              AccountBOLevel: postAccount.AccountBOLevel,
              AccountRegulatedCustomer: postAccount.AccountRegulatedCustomer,
              AccountIsPhysical: postAccount.AccountIsPhysical,
              RepId: postAccount.RepId,
              MainAdvisorId: postAccount.MainAdvisorId,
              AccountCommissionsCanBeChanged: postAccount.AccountCommissionsCanBeChanged,
              AccountUseMarkUP: postAccount.AccountUseMarkUP,
              AccountProfileObjectiveSpecify: postAccount.AccountProfileObjectiveSpecify,
              AccountKnowledgeStockMarket: postAccount.AccountKnowledgeStockMarket,
              AccountInvestBonds: postAccount.AccountInvestBonds,
              AccountInvestStocks: postAccount.AccountInvestStocks,
              AccountInvestFunds: postAccount.AccountInvestFunds,
              AccountInvestOthers: postAccount.AccountInvestOthers,
              AccountWayGiveOrders: postAccount.AccountWayGiveOrders,
              AccountSignature: postAccount.AccountSignature,
              AccountFoundsOriginCapitalCont: postAccount.AccountFoundsOriginCapitalCont,
              AccountFoundsOriginRelevantAss: postAccount.AccountFoundsOriginRelevantAss,
              AccountFoundsOriginOthers: postAccount.AccountFoundsOriginOthers,
              AccountFoundsOriginOthersSpeci: postAccount.AccountFoundsOriginOthersSpecify,
              AccountKYCCustomerLink: postAccount.AccountKYCCustomerLink,
              AccountKYCCustomerLinkSpecify: postAccount.AccountKYCCustomerLinkSpecify,
              AccountKYCCustomerRelatedSince: postAccount.AccountKYCCustomerRelatedSince,
              AccountKYCCustomerPersonalCont: postAccount.AccountKYCCustomerPersonalContact,
              AccountKYCLastPersonalContactP: postAccount.AccountKYCLastPersonalContactPlace,
              AccountKYCCustomerProfessionId: postAccount.AccountKYCCustomerProfessionId,
              AccountKYCCustomerProfessionNa: postAccount.AccountKYCCustomerProfessionName,
              AccountKYCAnualIncome: postAccount.AccountKYCAnualIncome,
              AccountKYCAvailabilitiesTempIn: postAccount.AccountKYCAvailabilitiesTempInvest,
              AccountKYCPatrimony: postAccount.AccountKYCPatrimony,
              AccountKYCPatrimonyId: postAccount.AccountKYCPatrimonyId,
              AccountKYCAmountDepositedStock: postAccount.AccountKYCAmountDepositedStock,
              AccountKYCAmountRetiredStocks: postAccount.AccountKYCAmountRetiredStocks,
              AccountKYCQuantityDepositedSto: postAccount.AccountKYCQuantityDepositedStocks,
              AccountKYCQuantityRetiredStock: postAccount.AccountKYCQuantityRetiredStock,
              AccountKYCAmountMaximumCustody: postAccount.AccountKYCAmountMaximumCustody,
              AccountKYCEstimatedAmount: postAccount.AccountKYCEstimatedAmount,
              AccountKYCBackUpDocumentation: postAccount.AccountKYCBackUpDocumentation,
              AccountKYCComments: postAccount.AccountKYCComments,
              AccountInbalanceType: postAccount.AccountInbalanceType,
              AccountProfileRiskId: postAccount.AccountProfileRiskId,
              AccountAutomaticCreditSink: postAccount.AccountAutomaticCreditSink,
              AccountAutomaticCreditCoupon: postAccount.AccountAutomaticCreditCoupon,
              AccountAsksCustody: postAccount.AccountAsksCustody,
              AccountDataCompletionPercentag: postAccount.AccountDataCompletionPercentage,
              MainAdvisorCommissionPercentag: postAccount.MainAdvisorCommissionPercentage,
              AccountCompanyLinkId: postAccount.AccountCompanyLinkId,
              AccountBookInfo: postAccount.AccountBookInfo,
              AccountCondensedActivity: postAccount.AccountCondensedActivity,
            },
          }),
        };
        services.fetchNewAccountBasicInfo(baseBody, (response) => {
          setLoadingSave(false);
          if (response && response.result) {
            if (response.result.Code === 200) {
              if (response.accountId && response.accountId > 0) {
                setRedirectAccount(response.accountId);
                showToast("Changes saved successfully");
              }
            } else {
              showToast(response.result.Description || "Changes not saved", true);
            }
          }
        });
      } else {
        const body = {
          account: postAccount,
          accountChangeType: getAccountType.Profile,
        };
        services.fetchNewAccount(body, (res) => {
          if (res) {
            const accnew = {
              ...postAccount,
              AccountOnboardingId: res.Id,
            };
            setAccountData({ ...accnew }, true);
            setLoadingSave(false);
            showToast("Changes saved successfully");
          }
        });
      }
    } else {
      const newErrors = preCheckAccountForm(postAccount, { skipAdvisorValidation: AutomaticRep });
      if (Object.keys(newErrors).length !== 0) {
        setErrors(newErrors);
        return;
      }
      const body = {
        account: {
          ...postAccount,
          isOnboardingAccount: newOnboardingVersion ? true : false,
        },
        accountChangeType: getAccountType.Profile,
      };
      setLoadingSave(true);
      setErrors(newErrors);

      services.fetchAccountUpdate(body, (res) => {
        if (res) {
          const { result } = res;
          if (result && result.Code === 200) {
            if (changedAccountRef.AccountWayGiveOrders !== fullaccount.AccountWayGiveOrders) {
              const newHolders = account.AccountInfoHolder
                ? fullaccount.AccountInfoHolder.map((h) => ({
                    ...h,
                    HoldersOrderWritten:
                      changedAccountRef.AccountWayGiveOrders === AccountWayOfAction.Written,
                    HoldersOrderManaged:
                      changedAccountRef.AccountWayGiveOrders === AccountWayOfAction.Managed,
                    HoldersOrderWeb: false,
                    HoldersOrderViaLink: false,
                  }))
                : [];
              setAccountData({ ...postAccount, AccountInfoHolder: newHolders }, true);
            } else {
              setAccountData({ ...postAccount }, true);
            }
            setChangedAccount({});
            setLoadingSave(false);
          } else {
            alert(result.Description);
            setLoadingSave(false);
          }
        } else {
          setLoadingSave(false);
        }
      });
    }
  };

  const revert = () => {
    setChangedAccount({});
    setErrors({});
  };

  const toggleDisable = () => {
    setDisabled((d) => !d);
    revert();
  };

  const onChange = (name, value, nameValue) => {
    const newChangedAccount = { ...changedAccount };
    switch (name) {
      case "AccountCompanyLinkId":
        newChangedAccount.AccountCompanyLinkName = nameValue;
        break;
      case "AccountCurrencyId":
        newChangedAccount.AccountCurrencyISO = nameValue;
        break;
      case "MainAdvisorId":
        newChangedAccount.MainAdvisorName = nameValue;
        break;
      default:
        break;
    }
    const newErrors = { ...errors };
    if (!loadingSave) {
      newChangedAccount[name] = value;
      delete newErrors[name];
      let index = undefined;
      if (name === "RepId") {
        for (let i = 0; i < reps.length; i += 1) {
          if (Number(value) === Number(reps[i].id)) {
            const adv = reps[i].advisors;
            index = adv.find((acc) => acc.id === account.MainAdvisorId);
            // for (let j = 0; j < adv.length; i += 1) {
            //   if (adv[j].id === account.MainAdvisorId) {
            //     index = i;
            //   }
          }
        }
        if (!index) {
          for (let i = 0; i < reps.length; i += 1) {
            if (Number(value) === Number(reps[i].id)) {
              newChangedAccount.MainAdvisorId = reps[Number(i)].advisors[0].id;
              newChangedAccount.MainAdvisorName = reps[Number(i)].advisors[0].name;
              delete newErrors.MainAdvisorId;
              delete newErrors.MainAdvisorName;
            }
          }
        }
      }
      setChangedAccount(newChangedAccount);
      setAccountData(newChangedAccount);
      setErrors(newErrors);
    }
  };

  useEffect(() => {
    valueref.current = changedAccount;
    const postAccount = {
      ...account,
      ...changedAccount,
    };
    const newErrors = preCheckAccountForm(postAccount, { skipAdvisorValidation: AutomaticRep });
    setErrors(newErrors);
    setTabErrors(Object.keys(newErrors).length !== 0);
  }, [changedAccount]);

  useEffect(() => {
    accountref.current = account;
  }, [account]);

  if (!account) {
    return <CircularProgress sm />;
  }

  return (
    <div>
      <ProfileForm
        account={{ ...account, ...changedAccount }}
        userType={userType}
        errors={errors}
        currencies={currencies}
        onChange={onChange}
        riskTypes={riskTypes}
        disabled={disabled}
        reps={reps}
        companyLinks={companyLinks}
        mode={mode}
        checkField={enableField}
        newTLFormulaEnabled={newTLFormulaEnabled}
        AutomaticRep={AutomaticRep}
        userRoles={userRoles}
        services={services}
      />
      {disabled && mode !== AccountMode.New && !isReadOnly && (
        <Button color="secondary" onClick={toggleDisable} style={{ marginRight: 10 }}>
          <i className="fa fa-lock" /> Edit
        </Button>
      )}
      {!disabled && mode !== AccountMode.New && (
        <React.Fragment>
          <Button
            color="secondary"
            onClick={toggleDisable}
            disabled={loadingSave}
            style={{ marginRight: 10 }}
          >
            <i className="fa fa-unlock" /> Lock
          </Button>
          <Button style={{ marginRight: 10 }} disabled={loadingSave} onClick={() => revert()}>
            <i className="fa fa-undo" /> Revert
          </Button>
          <LaddaButton
            className="btn btn-ladda btn-primary"
            loading={loadingSave}
            onClick={() => handleSave()}
            data-style={EXPAND_RIGHT}
          >
            {loadingSave ? "Saving" : "Save"}
          </LaddaButton>
        </React.Fragment>
      )}
      {mode === AccountMode.New && (
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={loadingSave}
          onClick={() => handleSave()}
          data-style={EXPAND_RIGHT}
        >
          {loadingSave ? "Saving" : "Save"}
        </LaddaButton>
      )}
    </div>
  );
};

ProfileTab.propTypes = {
  account: PropTypes.object,
  currencies: PropTypes.array,
  riskTypes: PropTypes.array,
  setAccountData: PropTypes.func.isRequired,
  companyLinks: PropTypes.array,
  reps: PropTypes.array,
  services: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  userRoles: PropTypes.array,
  AutomaticRep: PropTypes.bool,
};

ProfileTab.defaultProps = {
  currencies: undefined,
  account: undefined,
  riskTypes: undefined,
  companyLinks: undefined,
  reps: undefined,
  userRoles: undefined,
  AutomaticRep: false,
};

export default ProfileTab;
